var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',{staticClass:"sublevel-ctr"},[(!_vm.isWindowSizeOK && !_vm.mapConfig.isDisabled)?_c('DimensionError'):_c('span',[(_vm.hasMapConfigBeenSet)?_c('SubMap',{attrs:{"mode":_vm.mode}}):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }